import { InjectionToken } from '@angular/core';
import { editor } from 'monaco-editor/esm/vs/editor/editor.api';

export const FEATURE_NAME = '@zerops/zui/code-field';

/**
 * Base URL the YAML JSON schemas are fetched from, without a trailing slash —
 * e.g. `https://api.app-prg1.zerops.io/api/rest/public`.
 *
 * monaco-yaml requests these itself via `enableSchemaRequest`, so they never pass
 * through the app's HTTP interceptor and must be absolute. Provide it from the app's
 * API URL so each environment validates against its own schemas; a staging build
 * hardcoded to production is what this token exists to avoid.
 *
 * Defaults to empty, which registers no schemas at all. That is deliberate: hosts
 * that do not serve these Zerops schemas should get no YAML validation rather than
 * validation against someone else's API.
 */
export const CODE_FIELD_SCHEMA_BASE_URL = new InjectionToken<string>(
  'zui-code-field/schema-base-url',
  { providedIn: 'root', factory: () => '' }
);

export const CODE_FIELD_DEFAULT_OPTIONS: editor.IStandaloneEditorConstructionOptions = {
  theme: 'vs-dark',
  padding: {
    top: 24,
    bottom: 24
  },
  roundedSelection: true,
  autoIndent: 'full',
  scrollBeyondLastLine: false,
  automaticLayout: true,
  minimap: {
    enabled: false
  },
  tabSize: 2,
  scrollbar: {
    alwaysConsumeMouseWheel: false,
  },
  renderWhitespace: 'all'
};
